import { Form, InputNumber } from "antd";
import { FormattedMessage } from "react-intl";

import "./index.css";

const { Item } = Form;

const InputNumberItem = ({
  validatorFunction,
  formItemLayout,
  inheritWidth,
  rangeMessage,
  initialValue,
  wrapperCol,
  addonAfter,
  fieldName,
  precision,
  onChange,
  disabled,
  labelCol,
  required,
  optional,
  message,
  onBlur,
  error,
  label,
  unit,
  min = 1,
  max = 9999,
}) => (
  <Item
    help={error}
    label={label}
    colon={false}
    name={fieldName}
    initialValue={initialValue}
    validateStatus={error ? "error" : null}
    labelCol={
      labelCol ? { span: labelCol } : formItemLayout && formItemLayout.labelCol
    }
    wrapperCol={
      wrapperCol
        ? { span: wrapperCol }
        : formItemLayout && formItemLayout.wrapperCol
    }
    rules={[
      {
        required: (required || message) && !optional,
        message: required ? (
          <FormattedMessage
            id="messages.input.required"
            defaultMessage="Tento údaj je povinný!"
          />
        ) : (
          message
        ),
      },
      ...(validatorFunction
        ? [{
            validator: validatorFunction,
          }]
        : []),
      {
        min,
        max,
        message: (rangeMessage && rangeMessage.replace("{max}", max)) || (
          <FormattedMessage
            id="messages.input.range"
            defaultMessage="Překročeno povolené rozmezí hodnot od {min} do {max}!"
            values={{ min, max }}
          />
        ),
        type: "number",
      },
    ]}
  >
    <InputNumber
      min={min}
      max={max}
      onBlur={onBlur}
      disabled={disabled}
      onChange={onChange}
      addonAfter={addonAfter}
      precision={precision || 0}
      className={inheritWidth ? "input-width" : ""}
      decimalSeparator={precision ? "," : undefined}
      formatter={(value) =>
        unit
          ? `${value} ${unit}`
          : precision && value
          ? value
              .toString()
              .replace(precision === 2 ? /[.,]00+$/ : /[.,]0+$/, "")
          : value
          ? value.toString().replace(".", "")
          : value
      }
      step={precision === 1 ? 0.1 : precision === 2 ? 0.01 : 1}
      parser={(value) => (unit ? value.replace(/[^0-9.,]/g, "") : value)}
    />
  </Item>
);

export default InputNumberItem;
